import { Subscription } from 'rxjs/Subscription';
import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ElementRef,
  HostListener,
} from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UsersService } from '../users.service';
import { T2CardComponent } from '../../../trip2-theme/components/t2-card/t2-card.component';
import { GridOptions } from 'ag-grid';
import { T2LoadingService } from '../../../trip2-theme/components/t2-loading/t2-loading.service';
import { ParentModule } from '../../A2-utils/ParentClass/parent-module';
import { constant } from 'app/app.constants';
import { ModalActiveService } from 'app/core/services/modalActive.service';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { ProvidersService } from 'app/pages/providers/providers.service';
import { IUser } from 'app/core/interfaces/user.interface';
import { take } from 'rxjs/operators';
import { normalizeWhitespace, isValidEmail, EMAIL_PATTERN, PHONE_PATTERN } from 'app/utils/helpers';
import { BooleanCheckComponent } from 'app/pages/A2-utils/grid-components/boolean-check/boolean-check.component';
import { IApiResponse } from 'app/core/interfaces/invoice-external.interface';

@Component({
  selector: 'app-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.scss']
})

export class UserFormComponent extends ParentModule implements OnInit, OnChanges, OnDestroy {
  @Input() usersId: number;
  @Input() usersModelPass: any;
  @Input() hideHistory: boolean;
  @Output() updateGrib?: EventEmitter <boolean> = new EventEmitter <boolean>();
  @Output() cancel: EventEmitter <boolean> = new EventEmitter <boolean>();
  @ViewChild('cardCreate') card: T2CardComponent;
  @ViewChild('modalChngPsswd') private modalChngPsswd: T2CardComponent;
  @ViewChild('modalFacility') private modalFacility: T2CardComponent;
  @ViewChild('autocompleteContainer') autocompleteContainer: ElementRef;
  public tab = 1;
  public minItems = 0;
  title: string;
  userForm: FormGroup;
  selectProvider = false;
  seletPayor = false;
  changePassword = true;
  authUser: any;
  selectUserTypes: any[];
  selectUserRoles: any[];
  selectUserPayors: any[];
  selectDefaultProviders: any[];
  selectDefaultFacility: any[];
  infoManagers: IUser[] = [];
  payersId = [];
  userfacilities = [];
  filteredManagers: IUser[] = [];
  gridFacilities: GridOptions;
  gridUsersHistory: GridOptions;
  gridManagedUsers: GridOptions;
  phoneMask = constant.MASK_PHONE;
  subscriptions: Subscription[] = [];
  switchBtn = true;
  dropdownSettings = {};
  managerId: number;
  providerList = [];
  isAdmin = false;
  canEditIsManager = false;
  managedUsersRows: any[] = [];
  selectedManagedUsersIds: number[] = [];
  private managedUsersRowsSubscription: Subscription;
  get isActive(): AbstractControl { return this.userForm.get('isactive'); }
  get inactivateReason(): AbstractControl { return this.userForm.get('inactivateReason'); }
  get userprofileid(): AbstractControl { return this.userForm.get('userprofileid'); }
  get userpayorsCtrl(): AbstractControl { return this.userForm.get('userpayors'); }
  get userfacilitiesCtrl(): AbstractControl { return this.userForm.get('userfacilities'); }
  get defaultfacilityidCtrl(): AbstractControl { return this.userForm.get('defaultfacilityid'); }

  constructor(
    protected  fb: FormBuilder,
    protected Inject: Injector,
    private usersService: UsersService,
    private _loadingUser: T2LoadingService,
    private loading: T2LoadingService,
    private modalActiveService: ModalActiveService,
    private toastrAlertHelper: ToastrAlertHelper,
    private sweetAlertHelper: SweetAlertHelper,
    private providerService: ProvidersService,
  ) {
    super('app-users', Inject);
    this.dropdownSettingsConfig();
    this.gridFacilities = <GridOptions>{};
    this.gridFacilities.columnDefs = this.columnDefs();
    this.gridUsersHistory = <GridOptions>{};
    this.gridUsersHistory.columnDefs = this.gridUserHistory();
    this.initGridManagedUsers();
    this.createForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['usersId']) {
      if (this.usersId !== null) {
        this.validateTab(this.tab);
        this.loadData(this.usersId);
        this.title = 'Edit User ' + this.usersModelPass.fullname;
        this.changePassword = true;
      }else {
        this.title = 'Add New User';
        this.changePassword = false;
      }
    }
  }

  ngOnInit() {
    this.getActionAdmin();
    this.getSelectAllUserType();
    this.getSelectAllRole();
    this.getSelectAllPayor();
    this.authUser = JSON.parse(localStorage.getItem('currentUser'));
    this.getProviders();
    this.getInfoManagers();
    this.setIsManagerState();
  }

  filterManagers(event: Event) {
    const input = event.target as HTMLInputElement;

    if (!input || !input.value || input.value.trim() === '') {
      this.userForm.patchValue({
          managerid:   null,
          managername: '',
        },
        { emitEvent: false },
      );
      this.filteredManagers = [];
      return;
    }
    const writtenvalue = input.value.toLowerCase();

    this.filteredManagers = this.infoManagers.filter((manager) =>
      manager.fullname.toLowerCase().includes(writtenvalue)
    );
  }

  selectManager(manager: IUser) {
    this.userForm.patchValue({
      managerid: manager.userprofileid,
      managername: normalizeWhitespace(manager.fullname)
    });
    this.filteredManagers = [];
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (
      this.autocompleteContainer &&
      !this.autocompleteContainer.nativeElement.contains(event.target)
    ) {
      this.filteredManagers = [];
    }
  }

  getInfoManagers() {
    this.subscriptions.push(
      this.usersService.infoManagers$.subscribe({
        next: (data) => {
          if (data && data.length) {
            this.infoManagers = data.filter((manager: IUser) => manager.ismanager);
            this.loadManagedUsersRows();
          }
        }
      })
    );
  }

  setIsManagerState() {
    const ctrl = this.userForm.get('ismanager');
    if (this.canEditIsManager) {
      ctrl.enable({ emitEvent: false });
    } else {
      ctrl.disable({ emitEvent: false });
    }
  }

  getActionAdmin() {
    this.actionsList$.subscribe({
      next: (value) => {
        this.isAdmin = value.includes('ModifyRoleAdmin');
        this.canEditIsManager = value.includes('ModifyManagerAdmin');
        this.setIsManagerState();
      },
    });
  }

  getProviders(): void {
    this.providerService.getCompaniesAll(false).subscribe((res: any) => {
      this.providerList = res.map((p: any) => {
        return { id: p.companyid, itemName: p.description };
      });
    },
      error => {
        this.sweetAlertHelper.captureException(error);
      }
    );
  }


  dropdownSettingsConfig(): void {
    this.dropdownSettings = {
      singleSelection: false,
      text: 'Select Provider',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: 'myclass custom-class',
      badgeShowLimit: 1
    };
  }

  columnDefs() {
    return [
      {
        headerName: 'Description',
        field: 'locationName',
        colid: 'locationName'
      },
      {
        headerName: '',
        field: '',
        colId: 'action',
        cellClass: ['icofont-trash'],
        cellStyle: {
          color: 'red',
          'font-size': '15px'
        },
        width: 30
      }
    ];
  }

  createForm() {
    this.userForm = this.fb.group({
      userprofileid:      null,
      managerid:          null,
      managername:        [''],
      isactive:           true,
      firstname:          ['', Validators.required],
      lastname:           ['', Validators.required],
      middleinitial:      '',
      emailaddress:       ['', [Validators.required, Validators.pattern(EMAIL_PATTERN)]],
      phone:              ['', Validators.pattern(PHONE_PATTERN)],
      usertypeid:         ['', Validators.required],
      roleid:             ['', Validators.required],
      defaultproviderid:  '',
      userproviders:      [],
      userpayors:         [],
      userfacilities:     [],
      enforcepasswordpolicies: false,
      defaultfacilityid:  '',
      inactivateReason: '',
      ismanager:          false,
      islogin:            false,
    });

    this.userForm.get('usertypeid').valueChanges.subscribe(val => {
      if (val !== null) {
        this.getRolesByUserType(val);

        this.userForm.get('defaultproviderid').clearValidators();
        this.userForm.get('userproviders').clearValidators();
        this.userForm.get('userpayors').clearValidators();
        this.userForm.updateValueAndValidity();

        this.userForm.patchValue({
          roleid:             '',
          defaultproviderid:  '',
          userproviders:      [],
          userpayors:         [],
          userfacilities:     [],
          defaultfacilityid:  '',
        });
      }

    });

    this.userForm.get('roleid').valueChanges.subscribe(val => {
      if (val !== null) {
        const usertypeid = this.userForm.get('usertypeid').value;
        if (usertypeid == 2) {
          this.seletPayor = false;
          this.selectProvider = true;
          this.userForm.controls['defaultproviderid'].setValidators([Validators.required]);
          this.userForm.controls['userproviders'].setValidators([Validators.required]);
        } if (usertypeid == 3) {
          this.seletPayor = true;
          this.selectProvider = false;
          this.userForm.controls['userpayors'].setValidators([Validators.required]);
        } if (usertypeid == 1) {
          this.seletPayor = false;
          this.selectProvider = false;
        }

      }
    });

    this.userForm.get('userproviders').valueChanges.subscribe(val => {
      if (val !== null) {
        const usertypeid = this.userForm.get('usertypeid').value;
        if (usertypeid == 2) {
          this.userForm.controls['defaultproviderid'].setValidators([Validators.required]);
        }
        this.getSelectDefaultProvider(val);
      }
    });

    this.userpayorsCtrl.valueChanges.subscribe({
      next: (resp: any) => {
        if (resp.length === 0) {
          this.selectDefaultFacility = [];
          this.defaultfacilityidCtrl.patchValue('');
          this.userfacilitiesCtrl.patchValue([]);
        }
      },
      error: (er: any) => {}
    });

    this.userfacilitiesCtrl.valueChanges.subscribe(val => {
      if (val !== null) {
        this.getSelectDefaultFacility(val);
        if (val.length > 0) {
          if (!isNaN(Number(this.defaultfacilityidCtrl.value)) ) {
            const resp = val.some((row: any) => row.facilityid === Number(this.userForm.get('defaultfacilityid').value) );
            if (!resp) {
              this.defaultfacilityidCtrl.setValue('');
            }
          } else {
            this.defaultfacilityidCtrl.setValue('');
          }
        }
      }
    });

    this.userForm.get('ismanager').valueChanges.subscribe((isManager: boolean) => {
      if (!isManager && this.tab === 3) {
        this.detailsUser();
      }

      if (isManager) {
        this.loadManagedUsersRows();
      }
    });
  }

  /**
   *
   * @param data
   */
  loadForm(data) {
    this.userForm.patchValue({
      managerid:          data.managerid,
      managername:        normalizeWhitespace(data.managername),
      userprofileid:      data.userprofileid,
      firstname:          data.firstname,
      lastname:           data.lastname,
      emailaddress:       data.emailaddress,
      isactive:           data.isactive,
      middleinitial:      data.middleinitial ? data.middleinitial.trim() : '',
      phone:              data.phone,
      usertypeid:         data.usertypeid,
      roleid:             data.roleid,
      defaultproviderid:  data.defaultproviderid,
      userproviders:      this.mapingProvider(data.userproviders),
      userpayors:         this.mapingPayor(data.userpayors),
      userfacilities:     this.mapingFacility(data.userfacilities),
      enforcepasswordpolicies: data.role.enforcepasswordpolicies,
      defaultfacilityid:  data.defaultfacilityid,
      ismanager:          data.ismanager,
      islogin:            data.islogin
    });

    this.switchBtn = data.isactive;
    this.getRolesByUserType(data.usertypeid);
    this.loadManagedUsersRows();
  }

  getSelectAllUserType() {
    this.usersService.getAllUserType()
      .subscribe(
        data => {
          if (this.authUser.usertypeid == 1) {
            this.selectUserTypes = data;
          } if (this.authUser.usertypeid == 2) {
            this.selectUserTypes = [{usertypeid: '2', description: 'Provider'}];
          } if (this.authUser.usertypeid == 3) {
            this.selectUserTypes = [{usertypeid: '3', description: 'Client'}];
          }
        }
      );
  }

  getSelectAllRole() {
    this.usersService.getRoles().subscribe((data) => {
      this.disabledIsAdmin(data);
    });
  }

  getSelectAllPayor() {
    this.usersService.getPayorList()
      .subscribe(data => {
        this.selectUserPayors = data;
      });
  }

  /**
   *
   * @param val
   */
  getSelectDefaultProvider(val) {
    this.selectDefaultProviders = val;
  }

  onDeselectItem(event) {
    const providerDefaulId = this.userForm.get('defaultproviderid').value;
    if (providerDefaulId === event.id) {
      this.userForm.patchValue({'defaultproviderid': ''});
    }
  }

  onDeSelectAll(): void {
    this.userForm.patchValue({ 'defaultproviderid': '' });
  }

  /**
   *
   * @param val
   */
  getSelectDefaultFacility(val) {
    this.selectDefaultFacility = val;
  }

  /**
   * @param id
   */
  loadData(id) {
    this.usersService
      .getUser(this.usersId).subscribe((resp) => {
        this.loadForm(resp);
      }
    );
  }

  /**
   *
   * @param providers
   */
  mapingProvider(providers) {
    const arrayProv = providers.map((item) => {
      return {id: item.providerid, itemName: item.provider.description };
    });
    return arrayProv;
  }

  /**
   *
   * @param payors
   */
  mapingPayor(payors) {
    const arrayPayor = payors.map((item) => {
      return {payorid: item.payorid, description: item.description};
    });
    return arrayPayor;
  }

  /**
   *
   * @param facility
   */
  mapingFacility(facility) {
    const arrayPayor = facility.map((item) => {
      return {
        facilityid: item.facilityid,
        description: item.facility.description,
        userfacilityid: item.userfacilityid,
        userprofileid: item.userprofileid
        };
    });
    return arrayPayor;
  }

  /**
   *
   * @param id
   */
  getRolesByUserType(id) {
    this.usersService.getRolesByUserType(id).subscribe((resp) => { this.disabledIsAdmin(resp); });
  }

  disabledIsAdmin(data: any) {
    this.selectUserRoles = data.filter((f: {isactive: any }) => f.isactive)
    .map((m) => {
      if (this.authUser.roleid === 1) {
        return m;
      } else if (m.description === 'Admin') {
        m['disabled'] = !this.isAdmin;
      }
      return m;
    });
  }

  cancelCreateEdit() {
    this.cancel.emit(false);
    this.userForm.reset();
    this.seletPayor = false;
    this.selectProvider = false;
  }

  onChangePassword() {
    this.modalChngPsswd.open();
  }

  /**
   *
   * @param message
   */
  onsuccesschange(message) {
    this.toastrAlertHelper.success(message);
  }

  /**
   *
   * @param $event
   */
  onCloseModal($event) {
    this.modalChngPsswd.close();
  }

  /**
   *
   * @param data
   */
  saveAction(data) {
    if (this.userForm.invalid) {
      this.toastrAlertHelper.error('Please fix the invalid fields before saving.');
      return;
    }
    const emailValue = this.userForm.get('emailaddress').value;
    if (emailValue && !isValidEmail(emailValue)) {
      this.toastrAlertHelper.error(
        'Please enter a valid email address',
        'Error',
      );
      return;
    }
    this._loadingUser.show();
    const dataForm = this.buildPayload();

    if (this.usersId !== null) {
      this.usersService.putData(dataForm)
        .finally(() => {
          this._loadingUser.hiden();
        })
        .subscribe(resp => {
          this.sweetAlertHelper.createCustomAlert({
            text: 'User has been updated',
            type: 'success'
          });
          this.updateGrib.emit();
          this.cancelCreateEdit();
        }, erro => {
          this.sweetAlertHelper.createCustomAlert({
            text: `${erro.message}`,
            type: 'error'
          });
        });
    }else {
      this.usersService.registerUser(dataForm)
        .finally(() => {
          this._loadingUser.hiden();
        })
        .subscribe(resp => {
          this.sweetAlertHelper.createCustomAlert({
            text: 'User was successfully created',
            type: 'success'
          });
          this.updateGrib.emit();
          this.cancelCreateEdit();
        }, erro => {
          this.sweetAlertHelper.createCustomAlert({
            text: `${erro.message}`,
            type: 'error',
          });
        });
    }

  }

  onToggleIsManager(event: Event): void {
    if (!this.canEditIsManager) {
      return;
    }

    const previousValue = !this.userForm.get('ismanager').value;

    this.confirmIsManagerToggleSaveAllChanges().then((result: any) => {
      if (!result || !result.value) {
        this.revertIsManagerToggle(previousValue);
        return;
      }

      this.persistIsManagerToggle(previousValue);
    });
  }

  private confirmIsManagerToggleSaveAllChanges() {
    return this.sweetAlertHelper.createCustomAlert({
      title: 'Confirm manager status change',
      text: 'Changing this switch will save all current form changes. Do you want to continue?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, save all changes',
      cancelButtonText: 'Cancel',
    });
  }

  private revertIsManagerToggle(previousValue: boolean): void {
    this.userForm.patchValue(
      { ismanager: previousValue },
      { emitEvent: false },
    );
  }

  private persistIsManagerToggle(previousValue: boolean): void {
    const dataForm = this.buildPayload();
    this._loadingUser.show();
    this.usersService
      .putData(dataForm)
      .finally(() => {
        this._loadingUser.hiden();
      })
      .subscribe({
        next: (res: IApiResponse) => {
          if (res) {
            this.sweetAlertHelper.createCustomAlert({
              title: 'Success',
              text: res.message,
              type: 'success',
            });
            this.updateGrib.emit();
          }
        },
        error: (error) => {
          this.sweetAlertHelper.captureException(error);
          this.revertIsManagerToggle(previousValue);
        },
      });
  }

  private buildPayload() {
    const formRawValue = this.userForm.getRawValue();
    const isManager = formRawValue.ismanager;
    const payload = Object.assign({}, formRawValue);
    const normalizedManagerName = normalizeWhitespace(payload.managername);
    if (!normalizedManagerName) {
      payload.managerid = null;
      payload.managername = '';
    }
    payload.ismanager = isManager;
    payload.userproviders = this.mapUserProvidersForPayload(formRawValue.userproviders);

    return payload;
  }

  private mapUserProvidersForPayload(userProviders: any[]) {
    if (!userProviders || !userProviders.length) {
      return [];
    }

    return userProviders.map((provider) => ({
      providerid: provider.id,
      description: provider.itemName,
    }));
  }

  detailsUser() {
    this.tab = 1;
  }

  historyUser() {
    this.tab = 2;
    if (this.usersId) {
      this.loading.show('Loading UserProfile History');
      this.usersService.userProfileHistory(this.usersId).subscribe(resp => {
        this.gridUsersHistory.api.setRowData(resp);
        this.loading.hiden();
      });
    }
  }

  managedUsersTab() {
    this.tab = 3;
    this.loadManagedUsersRows();
  }

  gridUserHistory() {
    return [
      {
        headerName: 'Date',
        field: 'date',
        width: 73
      },
      {
        headerName: 'Time',
        field: 'time',
        width: 54
      },
      {
        headerName: 'Description',
        field: 'description',
        width: 400
      },
      {
        headerName: 'User',
        field: 'userprofiledata.fullname',
        width: 120
      },
    ];
  }


  initGridManagedUsers(): void {
    this.gridManagedUsers = {
      rowSelection: 'multiple',
      columnDefs: this.gridManagedUsersColumns(),

      onSelectionChanged: () => {
        this.updateSelectedManagedUsers();
      },

      onGridReady: (params) => {
        if (params && params.api) {
          params.api.setRowData([]);
          this.loadManagedUsersRows();
        }
      },
    };
  }

  gridManagedUsersColumns() {
    return [
      {
        headerName: 'Chek',
        colId: 'selection',
        checkboxSelection: true,
        headerCheckboxSelection: true,
        width: 45,
      },
      {
        headerName: 'Full Name',
        field: 'fullname',
      },
      {
        headerName: 'Email',
        field: 'emailaddress',
      },
      {
        headerName: 'Role',
        field: 'role.description',
      },
      {
        headerName: 'Active',
        field: 'isactive',
        cellRendererFramework: BooleanCheckComponent
      }
    ];
  }

  private loadManagedUsersRows(): void {
    if (this.tab !== 3) {
      return;
    }

    const isManagerControl = this.userForm.get('ismanager');
    if (!this.userForm || !isManagerControl || !isManagerControl.value) {
      return;
    }

    if (!this.usersId) {
      return;
    }

    if (!this.gridManagedUsers || !this.gridManagedUsers.api) {
      return;
    }

    if (this.managedUsersRowsSubscription) {
      this.managedUsersRowsSubscription.unsubscribe();
    }

    this.managedUsersRowsSubscription = this.usersService
      .GetManagedUsers(this.usersId)
      .subscribe({
        next: (res: any) => {
          if (res && this.gridManagedUsers && this.gridManagedUsers.api) {
            this.gridManagedUsers.api.setRowData(res);
            this.gridManagedUsers.api.sizeColumnsToFit();
          }
        },
        error: (err) => {
          this.sweetAlertHelper.captureException(err);
        },
      });
  }

  private updateSelectedManagedUsers(): void {
    if (!this.gridManagedUsers || !this.gridManagedUsers.api) {
      this.selectedManagedUsersIds = [];
      return;
    }

    this.selectedManagedUsersIds = this.gridManagedUsers.api
      .getSelectedNodes()
      .map((node: any) => node.data.userprofileid);
  }

  removeManagedUsersRelation(): void {
    if (!this.selectedManagedUsersIds || !this.selectedManagedUsersIds.length) {
      return;
    }

    if (!this.usersId) {
      return;
    }

    this._loadingUser.show();
    this.subscriptions.push(
      this.usersService
        .removeManagedUsersRelation(this.selectedManagedUsersIds, this.usersId)
        .finally(() => {
          this._loadingUser.hiden();
        })
        .subscribe({
          next: (res: IApiResponse) => {
            if (res) {
              this.sweetAlertHelper.createCustomAlert({
                title: 'Success',
                text: res.message,
                type: 'success',
              });
              this.selectedManagedUsersIds = [];
              this.loadManagedUsersRows();
              this.updateGrib.emit();
            }
          },
          error: (error) => {
            this.sweetAlertHelper.captureException(error);
          },
        }),
    );
  }

  validateTab(tab: number) {
    switch (tab) {
      case 1:
        this.detailsUser();
        break;
      case 2:
        this.historyUser();
        break;
      case 3:
        this.managedUsersTab();
        break;
      default:
        break;
    }
  }

  activeUser(event: Event): void {
    if (event.type == 'change') {
      if (!this.isActive.value) {
        this.modalActiveService.openModalActive('Reason for inactivation');
        this.modalActiveService.callBack$
          .pipe(take(1))
          .subscribe({
            next: (res: { value: any, cancel: boolean }) => {
              if (res.cancel) {
                this.isActive.patchValue(true);
                this.inactivateReason.patchValue('');
              } else {
                if (this.userprofileid.value !== null) {
                  this.inactivateReason.patchValue(res.value);
                  this.saveAction(this.userForm.value);
                } else {
                  this.inactivateReason.patchValue('');
                }
              }
            },
            error: (er: any) => this.toastrAlertHelper.error(er.error, 'Error')
          });
      } else {
        if (this.userprofileid.value !== null) {
          this.inactivateReason.patchValue('');
          this.saveAction(this.userForm.value);
        }
      }
    }
  }

  // loadGridFacilities(data) {
  //   this.userfacilities = data;
  //   this.gridFacilities.api.setRowData(this.userfacilities);
  //   this.gridFacilities.api.sizeColumnsToFit();
  //   return this.userfacilities;
  // }

  // onSelectOptionFacility(event) {
  //   // const userfacilities = event.facilityid;
  //   if (this.userfacilities.length > 0) {
  //     let existent = false;
  //     this.userfacilities.map( node => {
  //       if (node.facilityid === event.facilityid) {
  //         existent = true;
  //       }
  //     });
  //     if (existent === false) {
  //       this.userfacilities.push(event);
  //     }
  //     alert('mayor');
  //   } else {
  //     this.userfacilities.push(event);
  //     alert('menor');
  //   }
  //
  //   this.userForm.patchValue({
  //     userfacilities: this.userfacilities,
  //   });
  //
  //   this.gridFacilities.api.setRowData(this.userfacilities);
  //   this.gridFacilities.api.sizeColumnsToFit();
  // }

  // deleteRow(event) {
  //   if (event.colDef.colId === 'action') {
  //     this.gridFacilities.api.removeItems([event.node]);
  //     this.userfacilities.splice(event.node, 1);
  //   }
  // }

  currentListFac(event: any): void {
    if (event !== null) {
      this.getSelectDefaultFacility(event);
      this.userfacilitiesCtrl.patchValue(event);
    }
  }

  isPatternInvalid(controlName: string): boolean {
    const ctrl = this.userForm.get(controlName);
    return (
      ctrl &&
      ctrl.errors &&
      ctrl.errors['pattern'] &&
      (ctrl.dirty || ctrl.touched)
    );
  }

  get getValidatorProvider(): boolean {
    return this.userForm.controls['userproviders'].invalid;
  }

  get hasFilteredManagers(): boolean {
    return this.filteredManagers && this.filteredManagers.length > this.minItems;
  }

  get canShowManagedUsersTab(): boolean {
    return !!this.usersId && !!this.userForm && !!this.userForm.get('ismanager').value;
  }

  ngOnDestroy(): void {
    if (this.managedUsersRowsSubscription) {
      this.managedUsersRowsSubscription.unsubscribe();
    }
    this.subscriptions.map((subscribe: Subscription) => subscribe.unsubscribe());
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/users/user-form/user-form.component.ts